import config from '@/shared/constants/config';

class GoogleTagManagerService {
  send(obj: any) {
    if (config.ENVIRONMENT !== 3) {
      console.log(obj);
      return;
    }
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push(obj);
  }
}

const googleTagManagerService = new GoogleTagManagerService();

export { googleTagManagerService };
